import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Styles from "../../Styles/CommomDashboard/AvailableListing.module.css";
import FilterListIcon from "@mui/icons-material/FilterList";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CountDownTimer from "../../pages/DashBoard/countDownTimer";
import PreviewIcon from "@mui/icons-material/Preview";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import { useNavigate } from "react-router-dom";
import biddingConsumerService from "../Services/biddingConsumer.service";
import ApproveBidsModal from "../../pages/DashBoard/approveBidsModal";
import AddBidsModal from "../../pages/DashBoard/addBidsModal";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import FilterSection from "./FilterSection";
import MobileFilterModal from "./MobileFilterModal";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import biddingGeneratorService from "../Services/biddingGenerator.service";
import SideDrawer from "../../commons/SideDrawer";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseIcon from "@mui/icons-material/Close";

import DirectionsIcon from "@mui/icons-material/Directions";
import { CircularProgress } from "@mui/material";
import documentUploadService from "../Services/documentUpload.service";
import UploadedDocument from "../../pages/Documents/UploadedDocument";
import { CompanyCheck, TraderList } from "../../commons/TraderCheck";

const AvailableListing = ({
  matchingProfiles,
  getMatchingProfilesCon,
  selectedCardData,
  displayList,
  getMatchingProfiles,
  formResetFlag,
  setFIlterModal,
  filterModal,
  selectedCardIndex,
}) => {
  const navigation = useNavigate();
  const moment = require("moment");

  const role = useSelector((state) => state?.sessionState?.role);
  const configKey = useSelector((state) => state?.sessionState?.connectionName);

  let selUpperTender = displayList?.filter(
    (ele) => ele?.id === selectedCardIndex
  )?.[0];
  const upperEnergyType = selUpperTender?.energyType?.type;
  const traderList = useSelector(
    (state) => state?.analystReducer?.companyTraders
  );
  const selectedTrader = traderList?.filter(
    (ele) => ele?.id === selUpperTender?.traderAssigned
  )?.[0];

  let intraState = matchingProfiles?.filter(
    (ele) => ele?.company?.state === selUpperTender?.company?.state
  );

  const unreadNotificationsObj = useSelector(
    (state) => state?.notificationReducer?.unreadNotifications
  );
  const checkIntraState = selUpperTender?.isInterstate;
  const isVerified = useSelector((state) => state?.sessionState?.isVerified);

  const [statusDropDownValue, setStatusDropDownValue] = useState("");
  const [connectionData, setConnectionData] = useState({});
  const [isApproveBidsModal, setIsApproveBidsModal] = useState(false);
  const [bidItem, setbidItem] = useState({});
  const [isAddBidsModal, setIsAddBidsModal] = useState(false);
  const [bidsListing, setBidsListing] = useState([]);
  const [isBidPlaced, setIsBidPlaced] = useState([]);
  const [intraSelected, setIntraSelected] = useState(intraState?.length > 0);
  const [bitType, setBidType] = useState("");

  const [selectedFiles, setSelectedFiles] = useState(null);
  const [selectedFileData, setSelectedFileData] = useState(null);
  const [isPdfOpen, setIsPdfOpen] = useState(false);

  const [sortingItems, setSortingItems] = useState([
    {
      name: "Quantity (MW)",
      key: role === "CONSUMER" ? "sellEnergy" : "purchaseEnergy",
      value: "",
      clickCount: 0,
    },
    {
      name: "Energy Rate (₹ per Unit)",
      key: role === "CONSUMER" ? "sellingCost" : "landingCost",
      value: "",
      clickCount: 0,
    },
    // {
    //   name: "Profile matching",
    //   key: "profileMatching",
    //   value: ''
    // },
  ]);

  const handlecheckIntraState = () => {
    setIntraSelected(!intraSelected);
  };

  const handleSortClick = (key) => {
    let sortingItemsCopy = sortingItems.map((item) => {
      if (item.key === key) {
        const newClickCount = item.clickCount + 1;
        let newValue = "";

        switch (newClickCount % 3) {
          case 1:
            newValue = "ASC";
            break;
          case 2:
            newValue = "DESC";
            break;
          case 0:
            newValue = "";
            break;
          default:
            break;
        }

        return { ...item, value: newValue, clickCount: newClickCount };
      }
      return item;
    });

    setSortingItems(sortingItemsCopy);
    const sort = sortingItemsCopy.reduce((acc, item) => {
      if (item.value !== "") {
        acc[item.key] = item.value;
      }
      return acc;
    }, {});

    const reqBody = { sort };
    if (selectedCardData) {
      getMatchingProfilesCon(selectedCardData?.id, reqBody);
    }
  };

  const handleFilterDropdown = (value) => {
    setStatusDropDownValue(value);
    const requestBody = {
      search: [
        value !== "" && {
          operation: "LIKE",
          key:
            value === "PLACED" || value === ""
              ? role === "CONSUMER"
                ? "bids_consumerStatus"
                : "bids_generatorStatus"
              : role === "CONSUMER"
              ? "bids_generatorStatus"
              : "bids_consumerStatus",
          value: value,
          value1: null,
        },
        value === "PLACED" && {
          operation: "NOT",
          key:
            value === "PLACED" &&
            (role === "CONSUMER"
              ? "bids_generatorStatus"
              : "bids_consumerStatus"),
          value: "REJECTED",
          value1: null,
        },
        value === "PLACED" && {
          operation: "NOT",
          key:
            value === "PLACED" &&
            (role === "CONSUMER"
              ? "bids_generatorStatus"
              : "bids_consumerStatus"),
          value: "ACCEPTED",
          value1: null,
        },
      ].filter(Boolean),
    };
    if (displayList?.length > 0) {
      getMatchingProfilesCon(selectedCardData?.id, requestBody);
    }
  };

  const handleViewProfile = (item) => {
    localStorage.setItem("companyId", item?.company?.companyId);
    navigation("/company_profile");
  };

  const handleViewConnection = (item) => {
    let conCapId = role === "GENERATOR" ? item?.id : selectedCardData?.id;
    let genCapId = role === "GENERATOR" ? selectedCardData?.id : item?.id;
    role === "CONSUMER"
      ? biddingConsumerService
          .getConnectionDetails(conCapId, genCapId)
          .then((response) => {
            if (response?.data?.code === 200) {
              setIsApproveBidsModal(true);
              setConnectionData(response?.data?.data);
            }
          })
      : biddingGeneratorService
          .getConnectionDetails(conCapId, genCapId)
          .then((response) => {
            if (response?.data?.code === 200) {
              setIsApproveBidsModal(true);
              setConnectionData(response?.data?.data);
            }
          });
  };

  //  const getBidsListing = (id) => {
  //   biddingConsumerService
  //    .getBidsListByGenCapacityId(id)
  //    .then((response) => {
  //     if (response?.data?.code === 200) {
  //      setBidsListing(response?.data?.data);
  //     }
  //    })
  //    .catch((error) => {
  //     console.error("Api call error:", error);
  //    });
  //  };

  const handleAddBids = (item, type) => {
    console.debug("type", type);
    setbidItem(item);
    setBidType(type);
    setTimeout(() => {
      setIsAddBidsModal(true);
    }, 2000);
    // getBidsListing(item?.id)
  };

  const closeApproveBidsModal = () => {
    setIsApproveBidsModal(false);
  };

  const closeAddsBidsModal = () => {
    setIsAddBidsModal(false);
  };

  const handlePlaceBidText = (itemIndex) => {
    const updatedIsBidPlaced = [...isBidPlaced];
    updatedIsBidPlaced[itemIndex] = true;
    setIsBidPlaced(updatedIsBidPlaced);
  };
  useEffect(() => {
    if (!isAddBidsModal) {
      let elem = document.getElementsByTagName("body");
      elem.length > 0 && (elem[0].style.overflow = "");
    }
  }, [isAddBidsModal]);

  // const [traderDrawer, setTraderDrawer] = useState(false);

  //  const openTraderDrawer = () => {
  //   setTraderDrawer(true);
  //  };

  //  const closeTradeDrawer = () => {
  //   setTraderDrawer(false);
  //  };

  const handleViewFile = (id) => {
    getDocDataById(id, true);
  };

  const getDocDataById = (id, viewFile) => {
    documentUploadService
      .getDocumentById(id)
      .then((response) => {
        if (response?.data?.code === 200) {
          if (viewFile) {
            let fileTypeSplit = response?.data?.data?.fileName.split(".");
            setSelectedFiles(fileTypeSplit[fileTypeSplit?.length - 1]);
            setSelectedFileData(response?.data?.data?.fileInBytes);
            setIsPdfOpen(true);
          }
        }
      })
      .catch((err) => console.log("Api call Error:", err));
  };

  const handleClosePDFModal = () => {
    setIsPdfOpen(false);
  };
  return (
    <>
      {isPdfOpen && (
        <UploadedDocument
          fileData={selectedFileData}
          handleCloseModal={handleClosePDFModal}
          fileType={selectedFiles}
          isOpen={isPdfOpen}
          download={true}
        />
      )}
      {/* {true && (
       <div onClick={openTraderDrawer}>
        <MenuIcon />
       </div>
      )}
      {traderDrawer && (
       <div>
        <SideDrawer
         closeTradeDrawer={closeTradeDrawer}
         traderDrawer={traderDrawer}
        />
       </div>
      )} */}
      {isApproveBidsModal && (
        <ApproveBidsModal
          isOpen={isApproveBidsModal}
          comparedBids={connectionData}
          closeApproveBidsModal={closeApproveBidsModal}
          getMatchingProfiles={
            role === "GENERATOR" ? getMatchingProfiles : getMatchingProfilesCon
          }
          selectedCardData={selectedCardData}
        />
      )}
      {isAddBidsModal && (
        <AddBidsModal
          isOpen={isAddBidsModal}
          getMatchingProfiles={getMatchingProfiles}
          getMatchingProfilesCon={getMatchingProfilesCon}
          selectedCardData={selectedCardData}
          closeAddsBidsModal={closeAddsBidsModal}
          bidItem={bidItem}
          bidsListing={bidsListing}
          handlePlaceBidText={handlePlaceBidText}
          bitType={bitType}
        />
      )}

      {filterModal && (
        <MobileFilterModal
          selectedCardData={selectedCardData}
          getMatchingProfilesCon={getMatchingProfilesCon}
          getMatchingProfiles={getMatchingProfiles}
          formResetFlag={formResetFlag}
          filterModal={filterModal}
          setFIlterModal={setFIlterModal}
        />
      )}
      {/* <div className={Styles.switcherWrapper} >
        <div className={Styles.switcherBtn} onClick={openTraderDrawer}><FilterAltIcon /></div>
        </div> */}
      <div className={Styles.avaiCont}>
        <div className={Styles.listimeMainCont}>
          {isVerified && (
            <div className={Styles.filterMainContainer}>
              <div className={Styles.availableListText}>
                Available Listing :{" "}
                {checkIntraState
                  ? matchingProfiles?.filter(
                      (ele) =>
                        ele?.isInterstate === selUpperTender?.isInterstate
                    )?.length
                  : matchingProfiles?.filter(
                      (ele) =>
                        ele?.isInterstate === selUpperTender?.isInterstate &&
                        ele?.state === selUpperTender?.state
                    )?.length}
              </div>
              <div className={Styles.qtyFitlerContainer}>
                {sortingItems?.map((item, i) => (
                  <div
                    key={i}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSortClick(item.key)}
                    className={Styles.fiterButton}
                  >
                    {item.name}
                    {item.value === "DESC" && (
                      <ArrowDownwardIcon style={{ fontSize: "20px" }} />
                    )}
                    {item.value === "ASC" && (
                      <ArrowUpwardIcon style={{ fontSize: "20px" }} />
                    )}
                  </div>
                ))}
                {/* <div
                  className={
                    intraSelected
                      ? Styles.intraStateButton
                      : Styles.intraStateButtonInactive
                  }
                  onClick={handlecheckIntraState}
                >
                  <span>Intrastate</span>
                  {intraSelected && (
                    <span>
                      <CloseIcon style={{ height: "16px" }} />
                    </span>
                  )}
                </div> */}
              </div>
              <div>
                <FilterListIcon
                  style={{ fontSize: "25px", color: "#5c79e0" }}
                />
                <select
                  name="connectionStatus"
                  value={statusDropDownValue}
                  onChange={(e) => {
                    handleFilterDropdown(e.target.value);
                  }}
                  className="custom-select-filters"
                >
                  <option value="">All</option>
                  <option value="PLACED">Placed</option>
                  <option value="ACCEPTED">Connected</option>
                  <option value="REJECTED">Declined</option>
                </select>
              </div>
              {isVerified && (
                <div
                  className={Styles.filterButton}
                  onClick={() => setFIlterModal(true)}
                >
                  Filters
                </div>
              )}
            </div>
          )}
          {matchingProfiles?.length > 0 && (
            <div className={Styles.eachProfileSrctionMain}>
              {(checkIntraState
                ? matchingProfiles?.filter(
                    (ele) =>
                      ele?.isInterstate === selUpperTender?.isInterstate &&
                      (ele?.energyType === upperEnergyType || "Any") 
                  )
                : matchingProfiles?.filter(
                    (ele) =>
                      ele?.isInterstate === selUpperTender?.isInterstate &&
                      ele?.state === selUpperTender?.state &&
                     ( ele?.energyType === upperEnergyType || "Any")
                  )
              )?.map((item, i) => {
                const itemExpiryDate = moment(
                  `${item?.expiryAt}`,
                  "DD-MMM-yyyy hh:mm A"
                );

               
                return (
                  <div key={i} className={Styles.profilesMainContainer}>
                    <div className={Styles.headingLayer}>
                      {!item?.isTcRequest &&
                        (item?.generatorStatus === "ACCEPTED" ||
                          item?.consumerStatus === "ACCEPTED") && (
                          <div className={Styles.detailsLine1}>
                            <div>{item?.company?.companyName}</div>
                          </div>
                        )}
                      <div className={Styles.capacityName}>
                        {item?.capacityName}
                      </div>
                      {unreadNotificationsObj[item.capacityName] ? (
                        <OverlayTrigger
                          placement="right"
                          overlay={
                            <Tooltip>
                              {unreadNotificationsObj[item.capacityName]}
                            </Tooltip>
                          }
                        >
                          <NotificationsActiveIcon
                            style={{ fontSize: "20px" }}
                          />
                        </OverlayTrigger>
                      ) : (
                        <NotificationsNoneIcon style={{ fontSize: "20px" }} />
                      )}
                    </div>
                    <div className={Styles.listingDetailsMain}>
                      <div className={Styles.listingDetailsContainer}>
                        <div className={Styles.detailingData}>
                          <div>Region</div>
                          <div>{item?.company?.region}</div>
                        </div>
                        <div className={Styles.detailingData}>
                          <div>State</div>
                          <div>{item?.company?.state}</div>
                        </div>
                        <div className={Styles.detailingData}>
                          <div>Credit Rating</div>
                          <div>{item?.company?.creditRating}</div>
                        </div>
                        <div className={Styles.detailingData}>
                          <div>Quantity (MW)</div>
                          <div>{item?.energyInMW?.toFixed(2)}</div>
                        </div>
                      </div>
                      <div className={Styles.listingDetailsContainer}>
                        <div className={Styles.detailingData}>
                          <div>Energy Rate (₹ per Unit)</div>
                          <div>
                            {item?.energyRateStr
                              ? item?.energyRateStr
                              : item?.capacityName?.split("")?.[0] === "G"
                              ? `${item?.generatorPerUnitCost.toFixed(2)}`
                              : `${item?.consumerLandedCost.toFixed(2)}`}
                          </div>
                        </div>
                        <div className={Styles.detailingData}>
                          <div>Capacity Start & End Date</div>
                          <div>
                            {moment(item?.dateStartAt).format("DD-MMM-yyyy")}/
                            {moment(item?.dateEndAt).format("DD-MMM-yyyy")}
                          </div>
                        </div>
                        <div className={Styles.detailingData}>
                          <div>Capacity Start & End Time</div>
                          <div>
                            {item?.slotStartAt}/
                            {item?.slotEndAt && item.slotEndAt === "23:59"
                              ? "24:00"
                              : item?.slotEndAt}
                          </div>
                        </div>
                        {item?.tncDocument && (
                          <div className={Styles.detailingData}>
                            <div>Terms and Conditions</div>
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                handleViewFile(item?.tncDocument);
                              }}
                            >
                              <RemoveRedEyeIcon
                                style={{ fontSize: "20px", color: "orange" }}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={Styles.expairyContainer}>
                      <div className={Styles.expiringOnText}>Expires on :-</div>
                      <CountDownTimer targetDate={itemExpiryDate} />
                    </div>
                    {/* <div className={Styles.alterSectionMain}>
                        <div
                          className={Styles.eachProfileSrction}
                          onClick={() => handleViewProfile(item)}
                        >
                          <PreviewIcon
                            style={{
                              height: "25px",
                              width: "25px",
                              color: "#FF7D00",
                            }}
                          />
                          <div style={{ color: "#FF7D00" }}>View Profile</div>
                        </div>
                        {(item?.generatorStatus === "ACCEPTED" ||
                          item?.generatorStatus === "REJECTED" ||
                          item?.consumerStatus === "ACCEPTED" ||
                          item?.consumerStatus === "REJECTED") && (
                          <div
                            className={Styles.eachProfileSrction}
                            onClick={() => handleViewConnection(item)}
                          >
                            <RemoveRedEyeIcon
                              style={{ height: "25px", width: "25px" }}
                            />
                            <div style={{ textTransform: "capitalize" }}>
                              View {configKey}
                            </div>
                          </div>
                        )}
                        <div
                          className={Styles.eachProfileSrction}
                          onClick={() => handleAddBids(item)}
                        >
                          {item?.isEditable ? (
                            <WysiwygIcon
                              style={{ height: "25px", width: "25px" }}
                            />
                          ) : (
                            <PersonAddIcon
                              style={{ height: "25px", width: "25px" }}
                            />
                          )}
                          <div style={{ textTransform: "capitalize" }}>
                            {item?.isEditable
                              ? `Edit ${configKey} Request `
                              : `Request to Connect`}
                          </div>
                        </div>
                      </div> */}
                    {selUpperTender?.isPushed ? (
                      <div className={Styles.alterSectionMain}>
                        Your listing has been successfully pushed for Bilateral
                        Connection; create a new listing or duplicate your
                        existing one to gain more connections.
                      </div>
                    ) : item?.isPushed ? (
                      <div className={Styles.alterSectionMain}>
                        Bilateral Connection
                      </div>
                    ) : (
                      <div className={Styles.alterSectionMain}>
                        {!item?.isTcRequest &&
                          !(
                            CompanyCheck.includes(item?.company?.companyId) ||
                            CompanyCheck.includes(
                              selUpperTender?.company?.companyId
                            )
                          ) && (
                            <div>
                              {item?.generatorStatus === "ACCEPTED" ||
                              item?.consumerStatus === "ACCEPTED" ? (
                                <div style={{ display: "flex", gap: "16px" }}>
                                  <div
                                    className={Styles.eachProfileSrction}
                                    onClick={() => handleViewProfile(item)}
                                  >
                                    <PreviewIcon
                                      style={{
                                        height: "25px",
                                        width: "25px",
                                        color: "#FF7D00",
                                      }}
                                    />
                                    <div style={{ color: "#FF7D00" }}>
                                      View Profile
                                    </div>
                                  </div>
                                  <div
                                    className={Styles.eachProfileSrction}
                                    onClick={() => handleViewConnection(item)}
                                  >
                                    <RemoveRedEyeIcon
                                      style={{
                                        height: "25px",
                                        width: "25px",
                                      }}
                                    />
                                    <div
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      View Direct {configKey}
                                    </div>
                                  </div>
                                  <div
                                    className={Styles.eachProfileSrction}
                                    onClick={() => handleAddBids(item, "OTC")}
                                  >
                                    <WysiwygIcon
                                      style={{
                                        height: "25px",
                                        width: "25px",
                                      }}
                                    />
                                    <div
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      Edit Direct {configKey} Request
                                    </div>
                                  </div>
                                </div>
                              ) : (item?.generatorStatus === "PLACED" ||
                                  item?.consumerStatus === "PLACED") &&
                                (item?.isTcRequest || item?.isOtcRequest) ? (
                                <div style={{ display: "flex", gap: "16px" }}>
                                  {/* <div
                                  className={Styles.eachProfileSrction}
                                  onClick={() => handleViewProfile(item)}
                                >
                                  <PreviewIcon
                                    style={{
                                      height: "25px",
                                      width: "25px",
                                      color: "#FF7D00",
                                    }}
                                  />
                                  <div style={{ color: "#FF7D00" }}>
                                    View Profile
                                  </div>
                                </div> */}
                                  <div
                                    className={Styles.eachProfileSrction}
                                    onClick={() => handleAddBids(item, "OTC")}
                                  >
                                    <WysiwygIcon
                                      style={{
                                        height: "25px",
                                        width: "25px",
                                      }}
                                    />
                                    <div
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      Edit Direct {configKey} Request
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div
                                  className={Styles.eachProfileSrction}
                                  onClick={() => handleAddBids(item, "OTC")}
                                >
                                  <PersonAddIcon
                                    style={{ height: "25px", width: "25px" }}
                                  />
                                  <div style={{ textTransform: "capitalize" }}>
                                    Direct
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        {item?.traderAssigned > 0 &&
                          selUpperTender?.traderAssigned > 0 &&
                          !item?.isOtcRequest && (
                            <>
                              {item?.isTcRequest ? (
                                <div
                                  className={Styles.eachProfileSrction}
                                  onClick={() =>
                                    handleAddBids(item, "TRADECONNECT")
                                  }
                                >
                                  <WysiwygIcon
                                    style={{ height: "25px", width: "25px" }}
                                  />
                                  <div style={{ textTransform: "capitalize" }}>
                                    Edit{" "}
                                    {selectedTrader?.userName?.split(
                                      "_"
                                    )?.[0] ||
                                      selectedTrader?.userName ||
                                      "Trader"}{" "}
                                    Connection
                                  </div>
                                </div>
                              ) : !(
                                  item?.isInterstate &&
                                  TraderList.includes(item?.traderAssigned)
                                ) ? (
                                <>
                                  {(CompanyCheck.includes(
                                    item?.company?.companyId
                                  ) ||
                                    CompanyCheck.includes(
                                      selUpperTender?.company?.companyId
                                    )) && (
                                    <div
                                      className={Styles.eachProfileSrction}
                                      onClick={() =>
                                        handleAddBids(item, "TRADECONNECT")
                                      }
                                    >
                                      <DirectionsIcon
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                        }}
                                      />
                                      <div>
                                        <span
                                          style={{
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          {selectedTrader?.userName ? (
                                            "Connect"
                                          ) : (
                                            <span>
                                              <CircularProgress size="1rem" />
                                            </span>
                                          )}
                                          {/* {selectedTrader?.userName?.split(
                                        "_"
                                      )?.[0] ||
                                        selectedTrader?.userName ||
                                        "Trader"} */}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                </>
                              ) : (
                                <>
                                  {console.debug(
                                    item?.isInterstate,
                                    TraderList.includes(item?.traderAssigned)
                                  )}
                                </>
                              )}
                            </>
                          )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        {isVerified && (
          <div className={Styles.filterSection}>
            <FilterSection
              selectedCardData={selectedCardData}
              getMatchingProfilesCon={getMatchingProfilesCon}
              getMatchingProfiles={getMatchingProfiles}
              formResetFlag={formResetFlag}
              setFIlterModal={setFIlterModal}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default AvailableListing;
